// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"genericIcon_iconWrapper__2ePdG","icon":"genericIcon_icon__SXxef"};